import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Form, Button, InputGroup, FormControl } from 'react-bootstrap';
import TableComp from '../Components/ReusableTable'
import { connect } from 'react-redux'
import {
  getSupplierPOs,
  getPOPurchaseOrders,
} from '../store/actions/supplierActions'
import SearchBar from '../Components/SearchBar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GetDocumentsForAdvance, postDocumentIDForPODetailsDocument, getPOSearch, UpdatePoStatusforPOacceptanceRequest, getSearchedPO, GetExcellExportData, getProjectAllocationByUserId, getQAActivity } from '../store/actions/poDetailsActions';
import { GetFilterList } from '../store/actions/masterActions'
import { uploadFileGeneric } from '../store/actions/fileActions';
import env from '../ENV';
import AuthHandlerInstance from '../Classes/AuthHandler'
import swal from '@sweetalert/with-react';
import toast from 'react-hot-toast';
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'
import PaginationComponent from '../Components/PaginationComponent';
import Loading from '../Components/Loader';
import RejectPOAcceptance from '../Components/RejectPOAcceptance';
import POCommentPopUp from '../Components/POCommentPopUp';
import Select, { components } from "react-select"
import formatDate from '../Classes/FormatDateTimeInIST';
import formatTime from '../Classes/FormatTime';
const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;

class HRAdminPurchaseOrders extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: new URLSearchParams(this.props.location.search).get("searchTerm") ? new URLSearchParams(this.props.location.search).get("searchTerm") : "",
      tableData: [],
      currentPage: new URLSearchParams(this.props.location.search).get("currentPage") ? new URLSearchParams(this.props.location.search).get("currentPage") : 1,
      totalPos: 0,
      posPerpage: new URLSearchParams(this.props.location.search).get("posPerpage") ? new URLSearchParams(this.props.location.search).get("posPerpage") : 10,
      loading: true,
      paymentTerm: "Y004",
      sortByWBS: new URLSearchParams(this.props.location.search).get("sortByWBS") ? (new URLSearchParams(this.props.location.search).get("sortByWBS")).split(',') : [],
      sortByPlantCode: new URLSearchParams(this.props.location.search).get("sortByPlantCode") ? (new URLSearchParams(this.props.location.search).get("sortByPlantCode")).split(',') : [],
      sortByVendor: new URLSearchParams(this.props.location.search).get("sortByVendor") ? (new URLSearchParams(this.props.location.search).get("sortByVendor")).split(',') : [],
      sortByEmployees: new URLSearchParams(this.props.location.search).get("sortByEmployees") ? (new URLSearchParams(this.props.location.search).get("sortByEmployees")).split(',') : [],
      sortByPo: new URLSearchParams(this.props.location.search).get("sortByPo") ? (new URLSearchParams(this.props.location.search).get("sortByPo")).split(',') : [],
      sortByPurchaseGroup: new URLSearchParams(this.props.location.search).get("sortByPurchaseGroup") ? (new URLSearchParams(this.props.location.search).get("sortByPurchaseGroup")).split(',') : [],
      sortByLoc: [],
      sortBy: 'all',
      poDocStartDate: new URLSearchParams(this.props.location.search).get("poDocStartDate") ? new URLSearchParams(this.props.location.search).get("poDocStartDate") : "",
      poDocEndDate: new URLSearchParams(this.props.location.search).get("poDocEndDate") ? new URLSearchParams(this.props.location.search).get("poDocEndDate") : "",
      isShowFilter: false,
      isShowPoDocDate: false,
      searchForOptions: [
        {
          label: 'Currency', value: 'Currency'
        },
        {
          label: 'Location', value: 'Location'
        },
        {
          label: 'Material', value: 'Material'
        },
        {
          label: 'Payment term', value: 'Payment term'
        },
        {
          label: 'Plant Code', value: 'Plant Code'
        },
        {
          label: 'PO Number', value: 'PO Number'
        },
        {
          label: 'Purchase Group', value: 'Purchase Group'
        },
        {
          label: 'Status', value: 'Status'
        },
        {
          label: 'Vendor', value: 'Vendor'
        },
        {
          label: 'Project No.', value: 'WBS'
        },
      ],
      searchForItem: [],
      searchFor: new URLSearchParams(this.props.location.search).get("searchFor") ? new URLSearchParams(this.props.location.search).get("searchFor") : "",
    }
  }
  filterData = async (currentPage = 1) => {
    await this.setState({ loading: true })
    let tableData = []
    let totalPos = 0
    let searchData = {
      currentPage: currentPage,
      posPerpage: this.state.posPerpage,
      searchTerm: this.state.searchTerm,
      sortByEmployees: this.state.sortByEmployees,
      sortByPlantCode: this.state.sortByPlantCode,
      sortByWBS: this.state.sortByWBS,
      sortByPo: this.state.sortByPo,
      sortByPurchaseGroup: this.state.sortByPurchaseGroup,
      sortByVendor: this.state.sortByVendor,
      sortBy: this.state.sortBy,
      poDocStartDate: this.state.poDocStartDate,
      poDocEndDate: this.state.poDocEndDate,
      searchFor: this.state.searchFor,
      paymentTerm: this.state.paymentTerm,
    }
    this.props.history.push({
      pathname: '/hr-admin-purchase-orders',
      search: "?" + new URLSearchParams(searchData).toString()
    })

    await this.props.getPOSearch(searchData)
    if (this.props.poDetails && this.props.poDetails.poSearch && 'pos' in this.props.poDetails.poSearch) {
      tableData = this.props.poDetails.poSearch.pos
      totalPos = this.props.poDetails.poSearch.pageinfo.totalcount
    }
    await this.setState({ tableData, totalPos, loading: false, selectedFile: [], checkedArray: [], select: false })
  }

  dataSync = async () => {
    let roles = AuthHandlerInstance.getRoles()
    let userId = AuthHandlerInstance.getUserID()
    if (roles[12]) {
      let sortByWBS = []
      let WBSCode = []
      await this.props.getProjectAllocationByUserId({ UserId: userId })
      let ProjectCodes = await this.props.poDetails.getProjectAllocationByUserId
      if (ProjectCodes.length > 0) {
        ProjectCodes.map((elem) => {
          sortByWBS.push(elem.ProjectCode)
          WBSCode.push({ label: elem.ProjectCode, value: elem.ProjectCode })
        })
      }
      await this.setState({ sortByWBS, WBSCode })
    }
    await this.filterData(this.state.currentPage)
  }

  getFilterList = async () => {
    await this.props.GetFilterList()
    let finalvendorlist = []
    let finalpos = []
    let finalwbsno = []
    let finalplantcode = []
    let finalemployees = []
    let finalPurchaseGroup = []
    await finalemployees.push({ label: `Open`, value: 'opened' })
    await this.props.filterList[0].map(async (item) => {
      await finalemployees.push({ label: `${item.EmployeeName}`, value: item.EmployeeName })
    })
    await this.props.filterList[1].map(async (item) => {
      await finalplantcode.push({ label: item.PlantCode, value: item.PlantCode })
    })
    await this.props.filterList[2].map(async (item) => {
      await finalwbsno.push({ label: item.WBSCode, value: item.WBSCode })
    })
    await this.props.filterList[3].map(async (item) => {
      await finalvendorlist.push({ label: item.VendorName, value: item.VendorName })
    })
    await this.props.filterList[4].map(async (item) => {
      await finalpos.push({ label: item.POSAPId, value: item.POSAPId })
    })
    await this.props.filterList[9].map(async (item) => {
      await finalPurchaseGroup.push({ label: item.PurchaseGroup, value: item.PurchaseGroup })
    })

    let POSAPId = []
    let WBSCode = []
    let PlantCode = []
    let PurchaseGroup = []
    let VendorName = []
    let searchForItem = []
    await this.state.sortByPlantCode.map(async (item) => {
      await PlantCode.push({ label: item, value: item })
    })
    await this.state.sortByWBS.map(async (item) => {
      await WBSCode.push({ label: item, value: item })
    })
    await this.state.sortByPo.map(async (item) => {
      await POSAPId.push({ label: item, value: item })
    })
    await this.state.sortByVendor.map(async (item) => {
      await VendorName.push({ label: item, value: item })
    })
    await this.state.sortByPurchaseGroup.map(async (item) => {
      await PurchaseGroup.push({ label: item, value: item })
    })
    if (this.state.searchFor) {
      await searchForItem.push({ label: this.state.searchFor, value: this.state.searchFor })
    }

    await this.setState({ finalvendorlist, finalpos, finalwbsno, finalplantcode, finalemployees, PlantCode, WBSCode, POSAPId, VendorName, searchForItem, finalPurchaseGroup, PurchaseGroup })
  }
  componentDidMount = async () => {
    // this.props.getSupplierPOs(1);
    await this.dataSync()
    await this.getFilterList()
  }

  handleSelectPO = async (e) => {
    let sortByPo = []
    let POSAPId = []
    if (e.length > 0) {
      e.map((item) => {
        sortByPo.push(item.value)
        POSAPId.push(item)
      })
    }
    await this.setState({ sortByPo, POSAPId })
    await this.filterData()
  }
  handleSelectPurchaseGroup = async (e) => {
    let sortByPurchaseGroup = []
    let PurchaseGroup = []
    if (e.length > 0) {
      e.map((item) => {
        sortByPurchaseGroup.push(item.value)
        PurchaseGroup.push(item)
      })
    }
    await this.setState({ sortByPurchaseGroup, PurchaseGroup })
    await this.filterData()
  }
  handleSelectWBS = async (e) => {
    let sortByWBS = []
    let WBSCode = []
    if (e.length > 0) {
      e.map((item) => {
        sortByWBS.push(item.value)
        WBSCode.push(item)
      })
    }
    await this.setState({ sortByWBS, WBSCode })
    await this.filterData()
  }
  handleSelectLoc = async (e) => {
    let sortByLoc = []
    if (e.length > 0) {
      e.map((item) => {
        sortByLoc.push(item.value)
      })
    }
    await this.setState({ sortByLoc })
    // console.log(this.state.sortByLoc, "JJJJ")
  }

  handleSelectEmployees = async (e) => {
    let sortByEmployees = []
    let sortBy = 'all'
    let employees = []
    if (e.length > 0) {
      e.map((item) => {
        if (item.value !== 'opened') {
          sortByEmployees.push(item.value)
        } else {
          sortBy = 'opened'
        }
        employees.push(item)
      })
    }
    await this.setState({ sortByEmployees, employees, sortBy })
    await this.filterData()
  }

  handleSelectPlantCode = async (e) => {
    let sortByPlantCode = []
    let PlantCode = []
    if (e.length > 0) {
      e.map((item) => {
        sortByPlantCode.push(item.value)
        PlantCode.push(item)
      })
    }
    await this.setState({ sortByPlantCode, PlantCode })
    await this.filterData()
  }

  handleSelectVendor = async (e) => {
    let sortByVendor = []
    let VendorName = []
    if (e.length > 0) {
      e.map((item) => {
        sortByVendor.push(item.value)
        VendorName.push(item)
      })
    }
    await this.setState({ sortByVendor, VendorName })
    await this.filterData()
  }

  handleSelectPoPerPage = async (e) => {
    await this.setState({ posPerpage: e.value })
    await this.filterData()
  }

  handleSelectSearchFor = async (value) => {
    let searchFor = value
    let searchForItem = [
      {
        label: value, value: value
      }
    ]
    await this.setState({ searchFor, searchForItem })
  }


  handlepoDocStartDate = async (e) => {
    await this.setState({ poDocStartDate: e.target.value })
    await this.filterData()
  }
  handlepoDocEndDate = async (e) => {
    await this.setState({ poDocEndDate: e.target.value })
    await this.filterData()
  }
  toggleFilter = async () => {
    this.setState({ isShowFilter: !this.state.isShowFilter })
  }
  clearFilter = async () => {
    await this.setState({
      isShowFilter: false,
      currentPage: 1,
      posPerpage: 10,
      searchTerm: '',
      sortByEmployees: [],
      sortByPlantCode: [],
      sortByPurchaseGroup: [],
      sortByWBS: [],
      sortByPo: [],
      sortByVendor: [],
      sortBy: 'all',
      poDocStartDate: '',
      poDocEndDate: '',
      searchFor: '',
      POSAPId: [],
      PurchaseGroup: [],
      WBSCode: [],
      PlantCode: [],
      VendorName: [],
      searchForItem: [],
    })
    await this.filterData()
  }
  togglePoDocDate = async () => {
    this.setState({ isShowPoDocDate: !this.state.isShowPoDocDate })
  }

  render() {
    const { currentPage, posPerpage } = this.state;
    const currentTodos = this.state.tableData;
    const filteredTodos = this.state.tableData;
    const customStyles = {
      option: (provided, state) => ({
        ...provided,
        borderBottom: '1px dotted pink',
        //   color: state.isSelected ? 'red' : 'blue',
        padding: "2px 10px",
      }),
      menu: (provided, state) => ({
        ...provided,
        width: "100%",
        minWidth: "max-content",
        zIndex: "999 !important",
      }),
    }
    const tableConstants = () => {
      return [
        {
          title: <input type="checkbox" name="checked" checked={this.state.select} onChange={this.checkboxAll} />
          ,
          render:
            rowData => {

              return (

                <div>
                  <input type="checkbox" name="checked" checked={this.state.checkedArray.includes(rowData.PurchaseOrderId) ? true : false} value=""
                    onChange={(event) => {
                      this.changeCheckBoxStatus(rowData.PurchaseOrderId)
                    }
                    }
                    hidden={rowData.TrnStatusID == 1 && rowData.uploadId !== null ? false : true}
                  />
                </div>
              )
            },
        },
        {
          title: 'PO Number',
          render: rowData => {
            return <span>{rowData.POSAPId}</span>;
          },
        },
        {
          title: 'Project Code',
          render: rowData => {
            return <span>{rowData.ProjectCode ? rowData.ProjectCode.includes('ET') ? (rowData.ProjectCode).slice(0, 11) : (rowData.ProjectCode).slice(0, 6) : ""}</span>;
          },
        },
        {
          title: 'Plant Code',
          render: rowData => {
            return <span>{rowData.PlantCode ? rowData.PlantCode : ""}</span>;
          },
        },
        {
          title: 'Purchase Group',
          render: rowData => {
            return <span>{rowData.PurchaseGroup}</span>;
          },
        },
        {
          title: 'Vendor',
          render: rowData => {
            return <span>{rowData.VendorName}</span>;
          },
        },
        {
          title: 'Currency',
          render: rowData => {
            return <div className="amount-text"><span >{rowData.Currency}</span></div>;
          },
        },
        {
          title: 'PO Amount',
          render: rowData => {
            return <div className="amount-text"><span >{numberWithCommas(rowData.POAmount.toFixed(2))}</span></div>;
          },
        },

        {
          title: 'Location',
          render: rowData => {
            return <span>{rowData.Location}</span>;
          },
        },
        {
          title: 'PO Created On',
          render: rowData => {
            return <div style={{ minWidth: "100px" }}>{rowData.POCreationDate ? dateFormater(rowData.POCreationDate) : ""}</div>
          },
        },
        {
          title: 'Stat. Del. Date',
          render: rowData => {
            return <div style={{ minWidth: "100px" }}>{rowData.PODeliveryDate ? dateFormater(rowData.PODeliveryDate) : ""}</div>
          },
        },
        {
          title: 'Action',
          render: rowData => {
            return <>
              <div className="row text-center d-none d-sm-block headeralign">
                {rowData.PaymentTermId != 0 ?
                  <>
                    <Link to={{ pathname: '/PoAcceptanceTrail', state: { poId: rowData.PurchaseOrderId, poSAPId: rowData.POSAPId, PoAmount: rowData.POAmount } }}>
                      <FontAwesomeIcon icon={"eye"} color="black" title="View" size="lg" />
                    </Link>
                  </>
                  : null}
              </div>
            </>
          },
        },
      ];
    };
    if (this.props.poDetails.loading) {
      return (
        <Loading />
      )
    }
    return (
      <>
        <div className="Container-fluid p-4" style={{ opacity: this.state.opacity }}>
          <div className="row ">
            <div className="col-3">
              <div className="header"><b>Purchase Orders</b></div>
            </div>
            <div className="col xs={last} pt-2" style={{ paddingRight: 30 }}>
              {/* <SearchBar placeholder="Search" value={this.state.searchTerm} searchInputHandler={(e) => { this.handleISearch(e) }} searchClick={this.handleSearching} label="Search" btnName="" /> */}
              <SearchBar placeholder="Search" value={this.state.searchTerm} searchInputHandler={(e) => { this.handleISearch(e) }} searchClick={this.handleSearching} label="Search" toggleFilter={this.toggleFilter} clearFilter={this.clearFilter} filter={true} clear={true} btnName="" ShowSearchFor={true} searchForOptions={this.state.searchForOptions} searchForItem={this.state.searchForItem} SelectSearchForHandler={this.handleSelectSearchFor} />
            </div>
          </div>
          {this.state.isShowFilter ?
            <div className="row justify-content-between pb-3 pt-3 m-0 border-radius-modal filter-data pr-2 pl-2">
              {/* <div className="col">
                <Select maxMenuHeight={500} placeholder="Expeditor" isMulti value={this.state.employees} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalemployees} onChange={(e) => this.handleSelectEmployees(e)} />
              </div> */}
              <div className="col">
                <Select maxMenuHeight={500} placeholder="Project No." isMulti value={this.state.WBSCode} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalwbsno} onChange={(e) => this.handleSelectWBS(e)} />
              </div>
              <div className="col">
                <Select maxMenuHeight={500} placeholder="Vendor" isMulti value={this.state.VendorName} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalvendorlist} onChange={(e) => this.handleSelectVendor(e)} />
              </div>
              <div className="col">
                <Select maxMenuHeight={500} placeholder="Plant" isMulti value={this.state.PlantCode} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalplantcode} onChange={(e) => this.handleSelectPlantCode(e)} />
              </div>
              <div className="col">
                <Select maxMenuHeight={500} placeholder="PO No." isMulti value={this.state.POSAPId} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalpos} onChange={(e) => this.handleSelectPO(e)} />
              </div>
              <div className="col">
                <Select maxMenuHeight={500} placeholder="Purchase Group" isMulti value={this.state.PurchaseGroup} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalPurchaseGroup} onChange={(e) => this.handleSelectPurchaseGroup(e)} />
              </div>
              <div className="col">
                <InputGroup>
                  <FormControl className='outline-primary' type="text" readOnly placeholder="PO Dt." />
                  <InputGroup.Append>
                    <Button className="custom-drop-arrow" onClick={() => this.togglePoDocDate()} variant="outline-secondary"><FontAwesomeIcon icon={"chevron-down"} size="xs" /></Button>
                  </InputGroup.Append>
                </InputGroup>
                {this.state.isShowPoDocDate ?
                  <>
                    <label>Start Date</label>
                    <Form.Control className="width-90" type="date" onChange={(e) => { this.handlepoDocStartDate(e) }} placeholder="Start Date" value={this.state.poDocStartDate} />
                    <label>End Date</label>
                    <Form.Control className="width-90" type="date" onChange={(e) => { this.handlepoDocEndDate(e) }} id={`inspectionEndDate-datepicker`} name={`inspectionEndDate-datepicker`} placeholder="inspection End Date" value={this.state.poDocEndDate} />
                  </>
                  : null}
              </div>
            </div>
            : null}
          <div className="row sticky ">
            <div className="col wrap  ">
              {this.state.loading ?
                <Loading />
                :
                <TableComp
                  cols={tableConstants()}
                  data={currentTodos} />
              }
            </div>
          </div>
        </div>
        <div className="Container-fluid p-4">
          <div className="row">
            <div className="col">
              <hr></hr>
              <PaginationComponent filteredTodos={filteredTodos} currentPage={this.state.currentPage} posPerpage={posPerpage} totalPos={this.state.totalPos} handleClick={this.handleClick} handleSelectPoPerPage={this.handleSelectPoPerPage} showPosPerpage={true} />
              <hr></hr>
            </div>
          </div>
        </div>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  supplier: state.supplier,
  poDetails: state.poDetails,
  filterList: state.masterReducer.filterList,
  qaActivity: state.poDetails.qaActivity,

})
export default connect(mapStateToProps, {
  getSupplierPOs,
  getPOPurchaseOrders,
  UpdatePoStatusforPOacceptanceRequest, GetDocumentsForAdvance,
  uploadFileGeneric,
  postDocumentIDForPODetailsDocument,
  getPOSearch,
  getSearchedPO,
  GetFilterList,
  GetExcellExportData,
  getProjectAllocationByUserId,
  getQAActivity,
})(HRAdminPurchaseOrders)